import styled from 'styled-components';
import { PlusFileIcon, LampIcon, SettingIcon, SharedIcon, PdfIcon, UpArrowIcon } from '../../components/Icons';
import ReporterManagerIcon from 'src/components/Icons/reporterManagerIcon';

export const PageWrapper = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.primary};
  overflow-x: hidden;

  .react-switch {
    margin-right: 10px;
  }

  @media (max-width: 586px) {
    min-height: 100vh;
    height: auto;
    .cards{
      margin-top:${(props) => (props.hideSelector ? '-10px !important' : '')};
      margin-top: ${(props) => (props.isAdminEmployee ? '15px' : '-15px')};      
      transition: all 0.2s linear;
    }
    .inputs{
      opacity:${(props) => (props.hideSelector ? '0' : '1')};
      visibility:${(props) => (props.hideSelector ? 'hidden' : 'visible')};
      transition: all 0.1s linear;
    }

    }

  &.fullscreen {
    overflow: hidden;

    > .header {
      display: none;
    }

    > .content {
      width: 100%;
      height: auto;
      overflow: hidden;
    }
  }
`;

export const Header = styled.header`
  height: 162px;
  background-color:${(props) => props.theme.colors.backgroundColorHeader};
  border-bottom: 1px solid rgba(108, 108, 108, 0.1);
  transition: all 0.2s linear;
  @media (max-width: 586px) {
    height: ${(props) => (props.hideSelector ? '70px ' : '162px')};
  }
`;

export const FixedHeader = styled.div`
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 105px;
  width: 100%;
  flex-wrap: wrap;
  display: ${(props) => (props.isFullscreen ? 'none' : 'flex')};
  background-color:${(props) => props.theme.colors.backgroundColorHeader};
  padding: 23px 30px;  
  position:fixed;
  transition: all 0.2s linear;
  .logo{
    top: 30px;
    left: 21px;
    position: fixed;
  }
  .hide-menu{
    display: none;
  }
  @media (max-width: 360px) {
    .hide-menu{
      font-size: 6px !important;
    }
    .logo{
      width: 73px;
      top: 32px;
      left: 21px;
    }
  }  

  @media (max-width: 586px) {
    flex-direction: row;    
    height: ${(props) => (props.hideSelector ? '80px !important' : '')};
    height: ${(props) => (props.isAdminEmployee ? '197px' : '161px')};
    justify-content: space-between;
    padding: 15px 30px;
    .hide-menu{
      top: 27px;
      right: 25%;
      display: block;
      background-color:${(props) => props.theme.colors.backgroundColorHeader};
      border: 1px solid #00C6C9;
      height: 29px;
      width: 44%;
      position: fixed;
      font-size: 8px;
      padding-right: 0px;
      padding-left: 0px;
      font-family: "Roboto", "Helvetica neue", "Lato", sans-serif; 
    }    
    img {
      width: 80px;
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100vh;
  position: relative;
  background-color: ${(props) => props.theme.colors.backgroundColorPage};
  flex-shrink: 0;
  margin-bottom: 20px;
  border-radius: 5px;
  width: 100%;
  min-height: 100vh;

  @media (max-width: 586px) {
    max-width: 100%;
    border-radius: 0;
  }
`;

export const Footer = styled.footer`
  color: #fff;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  .copyright {
    span {
      font-size: 1.4rem;
    }
  }

  @media (max-width: 586px) {
    padding: 0 10px;
  }
`;

export const PlusFile = styled(PlusFileIcon)`
  width: 20px;
  height: 20px;
  margin: 5px 2px 0 0;
  fill:${(props) => props.theme.colors.menuIconTextColor};
  stroke:${(props) => props.theme.colors.menuIconTextColor};  
  @media (max-width: 586px) {
    fill:${(props) => props.theme.colors.menuMobileIconTextColor};
    stroke:${(props) => props.theme.colors.menuMobileIconTextColor};
  }
`;

export const Lamp = styled(LampIcon)`  
  width: 20px;
  fill:${(props) => props.theme.colors.menuIconTextColor};
  stroke:${(props) => props.theme.colors.menuIconTextColor};
  @media (max-width: 586px) {
    fill:${(props) => props.theme.colors.menuMobileIconTextColor};
  stroke:${(props) => props.theme.colors.menuMobileIconTextColor};
  }  
`;

export const Shared = styled(SharedIcon)`  
  width: 20px;
  fill:${(props) => props.theme.colors.menuIconTextColor};
  stroke:${(props) => props.theme.colors.menuIconTextColor};
  @media (max-width: 586px) {
    fill:${(props) => props.theme.colors.menuMobileIconTextColor};
    stroke:${(props) => props.theme.colors.menuMobileIconTextColor};
  }
`;

export const Setting = styled(SettingIcon)`  
  width: 20px;
  fill:${(props) => props.theme.colors.menuIconTextColor};
  stroke:${(props) => props.theme.colors.menuIconTextColor};
  @media (max-width: 586px) {
    fill:${(props) => props.theme.colors.menuMobileIconTextColor};
    stroke:${(props) => props.theme.colors.menuMobileIconTextColor};
  }
`;

export const Pdf = styled(ReporterManagerIcon)`  
  width: 20px;
  fill:${(props) => props.theme.colors.menuIconTextColor};  
  @media (max-width: 586px) {
    fill:${(props) => props.theme.colors.menuMobileIconTextColor};    
  }
`;

export const UpArrow = styled(UpArrowIcon)`  
  width: 20px;
  fill:${(props) => props.theme.colors.menuIconTextColor};
  ${(props) => (props.hideSelector ? 'transform: rotate(180deg); ' : 'transform: rotate(0deg);')}
  transition: 0.2s linear;
`;
